import { Component } from '@angular/core';
import { NavigationStart,Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs'
import { User} from 'src/app/Model/User/user.model';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { UserRole } from 'src/app/Model/Role/user-role.model';
import * as moment from 'moment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { speedDialFabAnimations } from './Components/speed-dial-fab.animations';
import { Pipe, PipeTransform} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from '@ngx-translate/core';
export let browserRefresh = false;
const MINUTES_UNITL_AUTO_LOGOUT = 60 //in mins
const CHECK_INTERVAL = 15000 // in ms 0.25min
const STORE_KEY =  'lastAction';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Component({
  animations: speedDialFabAnimations,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  direction="ltr";
  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
 public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }
  title = 'reception';
  currentUser: User;
  username;
  branch;
  loggedInUserId;
  subscription: Subscription;
  role;

  chat:Boolean=false;
  fabTogglerState = 'inactive';
  buttons = [];
  fabButtons = [
    
    {
      
      icon: 'chat',
      click:'getFabButtonOption("btn.click")',
      title: "Chat"
    },/**,,
    {
      icon: 'lightbulb_outline'
    },
    {
      icon: 'lock'
    }**/
  ];

  constructor(private router: Router,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private location: Location ) { 
     var lang= localStorage.getItem('language');
     this.changeLangage(lang);
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    //console.log(this.currentUser);
      if(this.currentUser){
      this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
      this.branch=this.currentUser.branch;
      this.role=this.currentUser.role;
      this.loggedInUserId=this.currentUser.userName;
//console.log(this.loggedInUserId);
}


//console.log(this.currentUser);
//console.log(this.loggedInUserId);
//console.log(this.chat);


let now = moment(); // add this 2 of 4
console.log('hello world', now.format()); // add this 3 of 4
console.log(now.add(7, 'days').format());



this.subscription = router.events.subscribe((event) => {
  if (event instanceof NavigationStart) {
    browserRefresh = !router.navigated;
  }
});

console.log(this.chat);

    }


    notificationchat($event){
      this.toggleChat();  
    }
    toggleChat(){
      console.log(this.chat);
if(this.chat){
this.chat=false;
}else{
  this.chat=true;
}
    }

  onActivate(event) {
    this.chat=false;
   // var chatwindow = document.getElementById("chatwindow");
   // console.log(chatwindow);
    //chatwindow.style.visibility = 'hidden';
    let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
            window.scrollTo({left: 0, top: pos - 200}); // how far to scroll on each step
            
        } else {
            window.clearInterval(scrollToTop);
        }
    }, 16);
  }


  changeLangage(lang: string) {
    console.log(lang);
    if(lang===null ||lang==''){
      lang='en';
    }
    console.log(lang);
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    localStorage.setItem('language',lang);
    if(lang=="ar"){
      this.direction="rtl";
    }else{
      this.direction="ltr";
    }
  }
  
  logout() {
    this.authenticationService.logout(this.username);
    this.router.navigate(['/login']);
}

    
  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover',()=> this.reset());
    document.body.addEventListener('mouseout',() => this.reset());
    document.body.addEventListener('keydown',() => this.reset());
    document.body.addEventListener('keyup',() => this.reset());
    document.body.addEventListener('keypress',() => this.reset());
  }
  
  reset() {
    this.setLastAction(Date.now());
  }
  
  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }
  
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
  
  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;
  
    if (isTimeout)  {
      localStorage.clear();
      location.reload();
     // this.authenticationService.logout
      this.router.navigate(['./login']);
      
    }
  }



  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }
  
  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }


  isSalesRep() {
    return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
  }

  isPowerUser() {
    return this.currentUser && this.currentUser.role === UserRole.PowerUser;
  }

  

}
